import React, { useContext } from 'react';
import { Container, Row } from 'react-bootstrap';
import { AuthStore } from '../../providers/auth';
import Carousel from './Carousel';
import { PensionIndexProvider, PensionIndexStore } from '../../providers/pensionIndex';
import { MobileCarousel } from '../MobileCarousel/MobileCarousel';
import SelectableCard from '../SelectableCard';

const CarouselDemoView = () => {
  const [, ,] = useContext(AuthStore) || [];
  const { companiesMessages } = useContext(PensionIndexStore) || {};

  console.log(companiesMessages);

  return (
    <Container className="p-0">
      <Container className="mt-10 p-0">
        <h4>Carousel Demo</h4>
        <Row>
          <Carousel data={companiesMessages} />
        </Row>
        <Row>
          <MobileCarousel chunkedData={companiesMessages}>

            <section className={'item-col p-5 pt-5 pb-7 rounded-1 col-12 col-lg-4'}>
              <SelectableCard
                title="401K"
                subtitle1="Imputed Income for tax purposes $2,250"
                radioButtonValue="3"

              ></SelectableCard>
            </section>
            <section  className={'item-col pt-5 pr-5 pb-7 rounded-1 col-12 col-lg-4'}>
              <SelectableCard
                title="402K"
                subtitle1="Imputed Income for tax purposes $2,250"
                radioButtonValue="3"
              ></SelectableCard>
            </section>
          </MobileCarousel>
        </Row>
      </Container>
    </Container>
  );
};

const CarouselDemo = () => {
  return (
    <PensionIndexProvider>
      <CarouselDemoView />
    </PensionIndexProvider>
  );
};

export default CarouselDemo;
